(() => {
  class SectionNav extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const trigger = event.target.closest('[data-section-nav-trigger]');
      if (!trigger || !this.contains(trigger)) return;

      const targetId = trigger.getAttribute('data-section-nav-target');
      if (targetId) {
        const target = document.getElementById(targetId);
        if (target) this.scrollToTarget(target);
        return;
      }

      const index = Array.from(this.querySelectorAll('[data-section-nav-trigger]')).indexOf(trigger);
      this.scrollToSection(index);
    }

    scrollToSection(index) {
      const section = this.closest('.shopify-section');
      if (!section || index < 0) return;

      let sibling = section.nextElementSibling;
      let position = 0;
      while (sibling) {
        if (sibling.classList.contains('shopify-section')) {
          if (position === index) {
            this.scrollToTarget(sibling);
            return;
          }
          position += 1;
        }
        sibling = sibling.nextElementSibling;
      }
    }

    scrollToTarget(target) {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-main-height')) || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  }

  if (!customElements.get('section-nav')) customElements.define('section-nav', SectionNav);
})();
